import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyAccountMiniWidgetSignupContainerClasses,
} from '@dxp-module/themes'

const miniWidgetSignupContainerStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountMiniWidgetSignupContainerClasses
>(
  () => ({
    root: {
      padding: 0,
      maxWidth: '100%',
    },
  }),
  { name: 'MyAccount_MyAccountMiniWidgetSignupContainer' }
)

export default miniWidgetSignupContainerStyles
